<div class="card">
  <div class="card-header">
    <h4 class="card-title float-left" id="basic-layout-form">{{ 'smsMessages.title' | translate }}</h4>
    <div class="clear-float-left"></div>
    <br>
    <button [disabled]="!sectionPermission.CanAdd" class="btn btn-raised btn-primary float-right" (click)="openModal()">
      <i
        class="ft-plus-circle"></i> {{ hasDesktopView ? ('smsMessages.addNewButtonText' | translate) : ('buttons.newText' | translate) }}
    </button>
    <input type='text' class="form-control form-control-sm filter-input"
           placeholder="{{'smsMessages.filterByRecipientPlaceHolder' | translate}}" (keyup)='searchFilter($event)'/>
  </div>
  <div class="card-body">
    <div [class]="hasDesktopView ? 'px-3' : 'px-0'">
      <table
        [class]="hasDesktopView ? 'table table-sortable table-responsive-md' : 'table-borderless table-sortable table-responsive-sm table'">
        <thead>
        <tr>
          <th *ngFor="let field of fieldCollection"
              [ngClass]="getTableHeaderClass(field.canSort, pageConfiguration.IsAscending, field.displayClass)"
              (click)="sort(field.canSort, field.name)">{{ field.displayName | translate }}
          </th>
          <th>{{ 'smsMessages.actionsFieldTitle' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let smsMessage of collection | paginate: { id: 'server', itemsPerPage: pageConfiguration.PageSize, currentPage: pageConfiguration.PageNumber, totalItems: pageConfiguration.TotalRecords }">
          <td class="d-none d-sm-table-cell">{{ smsMessage.SmsMessageId }}</td>
          <td class="col-sm-4 col-4">{{ smsMessage.Sender }}</td>
          <td>{{ smsMessage.RecipientPhonenumber }}</td>
          <td class="d-none d-sm-table-cell"><i [ngClass]="smsMessage.Status.IconClass"
                                                title="{{smsMessage.Status.Description}}"></i></td>
          <td>
            <a *ngIf="sectionPermission.CanView" class="succes" data-original-title=""
               title="{{'smsMessages.smsMessageDetailsTitle' | translate: smsMessage}}"
               (click)="openCustomModal('SmsMessageDetailsComponent', smsMessage)">
              <i class="ft-info font-medium-3 ml-1"></i>
            </a>
            <a *ngIf="hasSendPermission && smsMessage.Status.Code != 0" class="info"
               title="{{'smsMessages.sendSmsMessageTitle' | translate: smsMessage}}" (click)="send(smsMessage)">
              <i class="ft-message-square font-medium-3 ml-1"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination-controls *ngIf="pageConfiguration.TotalRecords > pageConfiguration.PageSize"
                           (pageChange)="pageChanged($event)" id="server"
                           previousLabel="{{'pagination.previousLabel' | translate}}"
                           nextLabel="{{'pagination.nextLabel' | translate}}">
      </pagination-controls>
    </div>
  </div>
</div>
